import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DraftConfirmationVm } from "@/model";
import { BookingInfo } from "@/types/components";

export interface BookingStoreState {
  bookingInfo: BookingInfo | null;
  draftInfo: DraftConfirmationVm | null;
  isLoading: boolean;
  acceptedTermsAndConditions: boolean;
  openModalTerms: boolean;
}

// Define the initial state using that type
const initialState: BookingStoreState = {
  bookingInfo: null,
  draftInfo: null,
  isLoading: true,
  acceptedTermsAndConditions: false,
  openModalTerms: false,
};

export const BookingStoreSlice = createSlice({
  name: "booking",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    resetStore: (state) => {
      return initialState;
    },
    setStoreIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStoreBookingInfo: (state, action: PayloadAction<BookingInfo>) => {
      state.bookingInfo = action.payload;
    },
    setStoreDraftInfo: (state, action: PayloadAction<DraftConfirmationVm>) => {
      state.draftInfo = action.payload;
    },
    setStoreAcceptedTermsAndConditions: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.acceptedTermsAndConditions = action.payload;
    },
    setStoreOpenModal: (state, action: PayloadAction<boolean>) => {
      state.openModalTerms = action.payload;
    },
  },
});

export const {
  setStoreIsLoading,
  resetStore,
  setStoreBookingInfo,
  setStoreDraftInfo,
  setStoreAcceptedTermsAndConditions,
  setStoreOpenModal,
} = BookingStoreSlice.actions;

export default BookingStoreSlice.reducer;

// function rejectWithValue(arg0: any): any {
//   throw new Error("Function not implemented.");
// }
